<template>
  <div id="dachbahn-konfigurator">
    <div class="gp-sections">
      <section class="gp-2-column !g-pb-[8px] !g-pt-[3rem]">
        <p class="gp-main-title"><span>DACH</span> <span>PLANER</span></p>
      </section>

      <gebaeudeart :position="1" :description="texts['1']"></gebaeudeart>
      <abmessungen :position="2" :description="texts['2']"></abmessungen>
      <dachraender :position="3" :description="texts['3']"></dachraender>
      <dachnutzung :position="4" :description="texts['4']"></dachnutzung>
      <untergrund :position="5" :description="texts['5']"></untergrund>
      <zubehoer :position="6" :description="texts['6']"></zubehoer>
      <zusammenstellung :position="7" :description="texts['7']"></zusammenstellung>
      <warenkorb :position="8" :description="texts['8']"></warenkorb>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ENV from "./environment";
import Abmessungen from "./sections/Abmessungen.vue";
import Dachnutzung from "./sections/Dachnutzung.vue";
import Dachraender from "./sections/Dachraender.vue";
import Gebaeudeart from "./sections/Gebaeudeart.vue";
import Untergrund from "./sections/Untergrund.vue";
import Warenkorb from "./sections/Warenkorb.vue";
import Zubehoer from "./sections/Zubehoer.vue";
import Zusammenstellung from "./sections/Zusammenstellung.vue";

export default {
  components: { Untergrund, Dachnutzung, Gebaeudeart, Abmessungen, Dachraender, Zubehoer, Zusammenstellung, Warenkorb },

  data() {
    return {};
  },

  created() {
    this.$store.dispatch("inhalt/fetchContent");
  },

  computed: {
    texts() {
      return this.$store.state.inhalt.texts;
    },
  },

  methods: {
    // async fetchContent() {
    //   let options = await axios.get(ENV.baseUrl + ENV.sheetsEndpoint + "?range=Titeltexte!A1:D20" + "&pluginSetPreview=" + ENV.setPreview);
    //   if (!options.data) return;
    //   let headers = options.data.shift(); // Get the first row, which contains the header names
    //   let descriptions = {};
    //   options.data.forEach((row, index) => {
    //     let rowAsObject = {};
    //     headers.forEach((header, index) => rowAsObject[header] = row[index]);
    //     row = rowAsObject;
    //     descriptions[row["Sektion"]] = row["Beschreibung"];
    //   });
    //   this.descriptions = descriptions;
    // },
  },
};
</script>

<style lang="scss">
#dachbahn-konfigurator {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 500px;

  .gp-sections > section {
    @apply g-px-8 g-py-4;

    &:nth-child(even) {
      @apply g-bg-grey-100;
    }
  }

  .gp-main-title {
    font-size: 2.8rem;
    font-weight: 900;
    margin-bottom: 1rem;

    & > span:first-child {
      @apply g-text-green-500;
      margin-right: -3px;
    }
  }
}
</style>
